var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGooglemaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 50,
    viewBox: "0 0 35 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5456_1188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.67773 37.0386C11.1237 38.8815 12.4398 40.8227 13.6166 42.8481C14.6212 44.7531 15.04 46.0447 15.7742 48.34C16.2245 49.6081 16.6314 49.9866 17.5063 49.9866C18.4598 49.9866 18.8923 49.3427 19.2265 48.3469C19.9205 46.1794 20.4651 44.5251 21.3242 42.962C23.01 39.9443 25.1048 37.2627 27.1632 34.6855C27.7204 33.9561 31.3231 29.7066 32.945 26.3536C32.945 26.3536 34.9385 22.6704 34.9385 17.5264C34.9385 12.7146 32.9726 9.37744 32.9726 9.37744L27.3125 10.8932L23.8751 19.9465L23.0247 21.1949L22.8547 21.421L22.6286 21.7041L22.2315 22.1563L21.6642 22.7235L18.6033 25.2172L10.9508 29.6358L9.67773 37.0386Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77954 25.7346C3.64725 30.0007 7.24889 33.7508 9.68567 37.0418L22.6286 21.7102C22.6286 21.7102 20.8052 24.095 17.4975 24.095C13.8132 24.095 10.8368 21.1529 10.8368 17.4431C10.8368 14.8991 12.3673 13.1514 12.3673 13.1514L3.58131 15.5056L1.77954 25.7346Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7731 0.788574C27.0718 2.17454 30.7511 5.08421 32.9766 9.37481L22.6325 21.7015C22.6325 21.7015 24.1631 19.9222 24.1631 17.394C24.1631 13.5978 20.9665 10.7619 17.5132 10.7619C14.2477 10.7619 12.3722 13.1427 12.3722 13.1427V5.37699L22.7731 0.788574Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15051 6.23501C6.71795 3.16322 11.2357 0 17.464 0C20.4858 0 22.7624 0.793324 22.7624 0.793324L12.3624 13.1493H4.99384L4.15051 6.23501Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77954 25.7345C1.77954 25.7345 0.0612793 22.3696 0.0612793 17.4949C0.0612793 12.8877 1.85229 8.86048 4.15052 6.23486L12.3682 13.1503L1.77954 25.7345Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5456_1188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.8774,
    height: 50,
    fill: "white",
    transform: "translate(0.0612793)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGooglemaps);
export default __webpack_public_path__ + "static/media/logo_googlemaps.41e3e22a5faf04ae1fc4e72fb5592a31.svg";
export { ForwardRef as ReactComponent };